/**
 * Founding Listener flag. Ops sets publicData.founding on the listener
 * user and each of their listings. Browse cards often have a sparse
 * author, so the listing flag is the source of truth on search results.
 */

const isTrue = value => value === true;

/**
 * True when this user, listing, or listing author is a Founding Listener.
 *
 * @param {Object} [entity] user, listing, or author-bearing listing
 * @returns {boolean}
 */
export const isFoundingListener = entity => {
  if (!entity || typeof entity !== 'object') {
    return false;
  }
  if (isTrue(entity.attributes?.publicData?.founding)) {
    return true;
  }
  if (isTrue(entity.attributes?.profile?.publicData?.founding)) {
    return true;
  }
  if (isTrue(entity.author?.attributes?.profile?.publicData?.founding)) {
    return true;
  }
  if (isTrue(entity.author?.attributes?.publicData?.founding)) {
    return true;
  }
  return false;
};
